module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[25]512.acd84fc.woff2";